import { render, staticRenderFns } from "./PT510OrderItemParts.vue?vue&type=template&id=c8d84eba&"
import script from "./PT510OrderItemParts.vue?vue&type=script&lang=js&"
export * from "./PT510OrderItemParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports